import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./VisualAcuity.css";

const VisualAcuity = () => {
useEffect(() => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}, []);
  const navigate = useNavigate();

  const [leftEye,setLeftEye] = useState("");
  const [rightEye,setRightEye] = useState("");
  const [bothEyes,setBothEyes] = useState("");
  const [message,setMessage] = useState("");
  const [glassesWorn, setGlassesWorn] = useState("");
  const [testedAt, setTestedAt] = useState("");

  /* ================= LOGIN PROTECTION ================= */

  useEffect(() => {

  const authed = localStorage.getItem("rg_auth") === "1";
  const email = localStorage.getItem("rg_email");

  if (!authed || !email) {
    alert("Access denied");
    navigate("/");
    return;
  }

  axios
    .get("/check-access", {
      params: {
        email: email,
        test: "visual_acuity",
      },
    })
    .then((res) => {

      if (!res.data.allowed) {
        alert("Access denied");
        navigate("/");
      }

    })
    .catch(() => {
      alert("Access denied");
      navigate("/");
    });

}, [navigate]);

  /* ================= SAVE RESULT ================= */

  const handleSubmit = async(e)=>{

    e.preventDefault();

    setMessage("");

     
  if(!bothEyes || !testedAt){
    setMessage("Both eyes & date/time required");
    return;
  }
    try{

      const email = localStorage.getItem("rg_email");

      await axios.post("/save-visual-acuity",{
      email,
      leftEye,
      rightEye,
      bothEyes,
      glassesWorn,
      testedAt
    });

      setMessage("Result saved successfully");

      setLeftEye("");
      setRightEye("");
      setBothEyes("");

    }catch(err){

      setMessage("Error saving result");

    }

  };

  return(

<section className="visual-section">

{/* ================= INTRO ================= */}

<div className="visual-container">

<h2 className="visual-title">
Visual Acuity in Sports
</h2>

<p className="visual-subtitle">
Visual acuity is the ability to <strong>resolve fine detail</strong>.
In sport it determines how early you pick up information and how confidently
your brain plans movement.
</p>

<hr className="visual-line"/>

<div className="why-card">

<h3 className="why-title">
Why it matters
</h3>

<p className="why-text">
Elite athletes process visual information extremely quickly.
Higher visual acuity helps you recognize cues earlier,
giving your brain more time to react and execute movement.
</p>

<div className="tag-container">
<span>Earlier reaction</span>
<span>Better tracking</span>
<span>Sharper focus</span>
<span>Faster decisions</span>
<span>Improved timing</span>
</div>

<ul className="why-list">

<li>
<strong>Earlier ball tracking:</strong> Detect ball movement sooner.
</li>

<li>
<strong>Improved anticipation:</strong> Read opponent actions faster.
</li>

<li>
<strong>More accurate timing:</strong> Strike or react at the right moment.
</li>

<li>
<strong>Reduced visual fatigue:</strong> Clearer vision lowers mental strain.
</li>

</ul>

</div>

</div>

{/* ================= MEASUREMENT ================= */}

<div className="measure-wrapper">

<div className="measure-card">

<h2>How to measure</h2>

<ul className="measure-list">

<li>Print the chart at <strong>100% size</strong></li>

<li>Stand at <strong>4 meters distance</strong></li>

<li>Cover one eye and read smallest line</li>

<li>Repeat for other eye and both eyes</li>

</ul>

<div className="measure-buttons">

<a
href="/visual-acuity-chart.pdf"
download
className="download-btn"
>
Download Chart
</a>

</div>

<hr/>

{/* ================= RESULT FORM ================= */}

<h3>Enter Your Result</h3>

<form onSubmit={handleSubmit} className="result-form">

<label>Left Eye</label>
<select
value={leftEye}
onChange={(e)=>setLeftEye(e.target.value)}
>
<option value="">Select</option>
<option value="6/60">6/60</option>
<option value="6/36">6/36</option>
<option value="6/24">6/24</option>
<option value="6/18">6/18</option>
<option value="6/12">6/12</option>
<option value="6/9">6/9</option>
<option value="6/6">6/6</option>
<option value="6/5">6/5</option>
<option value="6/4.5">6/4.5</option>
<option value="6/4">6/4</option>
<option value="6/3.5">6/3.5</option>
<option value="6/3">6/3</option>
<option value="6/2.5">6/2.5</option>
</select>

<label>Right Eye</label>
<select
value={rightEye}
onChange={(e)=>setRightEye(e.target.value)}
>
<option value="">Select</option>
<option value="6/60">6/60</option>
<option value="6/36">6/36</option>
<option value="6/24">6/24</option>
<option value="6/18">6/18</option>
<option value="6/12">6/12</option>
<option value="6/9">6/9</option>
<option value="6/6">6/6</option>
<option value="6/5">6/5</option>
<option value="6/4.5">6/4.5</option>
<option value="6/4">6/4</option>
<option value="6/3.5">6/3.5</option>
<option value="6/3">6/3</option>
<option value="6/2.5">6/2.5</option>
</select>

<label>Both Eyes *</label>
<select
value={bothEyes}
onChange={(e)=>setBothEyes(e.target.value)}
required
>
<option value="">Select</option>
<option value="6/60">6/60</option>
<option value="6/36">6/36</option>
<option value="6/24">6/24</option>
<option value="6/18">6/18</option>
<option value="6/12">6/12</option>
<option value="6/9">6/9</option>
<option value="6/6">6/6</option>
<option value="6/5">6/5</option>
<option value="6/4.5">6/4.5</option>
<option value="6/4">6/4</option>
<option value="6/3.5">6/3.5</option>
<option value="6/3">6/3</option>
<option value="6/2.5">6/2.5</option>
</select>
<label>Wearing Glasses?</label>
<select
  value={glassesWorn}
  onChange={(e)=>setGlassesWorn(e.target.value)}
>
  <option value="">Select</option>
  <option value="yes">Yes</option>
  <option value="no">No</option>
</select>

<label>Date & Time *</label>
<input
  type="datetime-local"
  value={testedAt}
  onChange={(e)=>setTestedAt(e.target.value)}
  className="date-input"
/>
<button
type="submit"
className="submit-result-btn"
>
Submit Result
</button>

</form>

{message && (
<div className="result-message">
{message}
</div>
)}

</div>

</div>

</section>

);

};

export default VisualAcuity;